export function SwiperVariables(dark: boolean) {
    if (dark) {
        return {
            '--swiper-scrollbar-size': '2px',
            '--swiper-scrollbar-drag-bg-color': 'var(--core60)',
            '--swiper-scrollbar-bg-color': 'var(--core10)',
        };
    }
    return {
        '--swiper-scrollbar-size': '2px',
        '--swiper-scrollbar-drag-bg-color': 'var(--core60)',
        '--swiper-scrollbar-bg-color': 'var(--core90)',
    };
}
